import { render, staticRenderFns } from "./TypeMint.vue?vue&type=template&id=614c2060&"
import script from "./TypeMint.vue?vue&type=script&lang=js&"
export * from "./TypeMint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports